export const mapContextKey = { key: Symbol() };
export const layerContextKey = { key: Symbol() };
